<template>
    <rkm-row>
        <rkm-col cols="2">
            <rkm-form-checkbox
                v-model="model.fornecimento.escovaDental"
                :disabled="model.exportacao"
            >
                Escova Dental
            </rkm-form-checkbox>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-checkbox
                v-model="model.fornecimento.cremeDental"
                :disabled="model.exportacao"
            >
                Creme Dental
            </rkm-form-checkbox>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-checkbox
                v-model="model.fornecimento.fioDental"
                :disabled="model.exportacao"
            >
                Fio Dental
            </rkm-form-checkbox>
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    props: {
        model: { type: Object, required: false }
    }
}
</script>
